import React, { Component } from "react";
import PropTypes from "prop-types";
import shadowfax from "../assets/shadowfax.jpg";
import appAnalytics from "../utils/appAnalytics";
import eventConfig from "../config/eventconfig";

class SfxAppLinkComponent extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  downloadSFXAPPClick = () => {
    let paramsString = window.location.search;
    let searchParams = new URLSearchParams(paramsString);
    let chatFormIdentifier = searchParams.get("id");
    let type = searchParams.get("type");
    let uniqueIdentifier = searchParams.get("c");
    // send lan on event
    appAnalytics.sendEventToMetabase(
      uniqueIdentifier,
      eventConfig.SFX_DOWNLOAD_BUTTON_CLICKED,
      {
        chat_identifier: chatFormIdentifier,
        type: type,
      }
    );
    window.open(
      "https://play.google.com/store/apps/details?id=in.shadowfax.gandalf"
    );
  };
  
  render() {
    return (
      <div>
        <div>
          <div onClick={this.downloadSFXAPPClick}>
            <img src={shadowfax} style={{ maxWidth: "100%", height: "auto" }} alt="Shadowfax" />
          </div>
        </div>

        <div>
          {this.props.chatFormIdentifier === "sfx_delhi"
            ? "Thanks for Applying, click karen "
            : "Thanks for Applying, Click "}
          <div style={{ color: "white" }} onClick={this.downloadSFXAPPClick}>
            {this.props.chatFormIdentifier === "sfx_delhi" ? "yahan" : "here"}
          </div>
          {this.props.chatFormIdentifier === "sfx_delhi"
            ? " aur upar di gayi information se uspr register karen/"
            : " to download the Shadowfax and register on it using above information."}
          {this.props.chatFormIdentifier === "sfx_delhi" ? (
            <div>
              आवेदन करने के लिए धन्यवाद, शैडोफैक्स डाउनलोड करने के लिए &nbsp;
              {/* eslint-disable jsx-a11y/anchor-is-valid */}
              <a style={{ color: "white" }} onClick={this.downloadSFXAPPClick}>
                यहां
              </a>
              {/* eslint-disable jsx-a11y/anchor-is-valid */}
              &nbsp; क्लिक करें और उपरोक्त जानकारी काउपयोग करके उस पर रजिस्टर
              करे
            </div>
          ) : null}
        </div>
        <br />
        <div onClick={this.downloadSFXAPPClick}>
          <div
            style={{
              background: "#fff",
              borderRadius: "5px",
              padding: "5px 7px",
              color: "#111",
              fontWeight: "700",
              boxShadow:
                "0px 2px 11px rgb(0 0 0 / 30%), 0px 2px 6px rgb(0 0 0 / 15%",
              width: "60%",
              margin: "5px auto",
            }}
            onClick={this.onConfirmButtonClick}
          >
            {this.props.chatFormIdentifier === "sfx_delhi"
              ? "Yahan click karen!/यहाँ क्लिक करें!"
              : "Click Here!"}
          </div>
        </div>
      </div>
    );
  }
}

SfxAppLinkComponent.propTypes = {
  steps: PropTypes.object,
};

SfxAppLinkComponent.defaultProps = {
  steps: undefined,
};

export default SfxAppLinkComponent;
